<div class="align-items-center flex justify-content-start">
  <div *ngIf="currentPath !== 'visits'" class="col-2"></div>
  <div class="col-gc15 viewBy-filter">
    <div class="field">
      <label>View By</label>
      <p-dropdown
        (onChange)="routeTo(selectViewByVisit)"
        [(ngModel)]="selectViewByVisit"
        [options]="viewByVisitDropdown"
        ngDefaultControl
      ></p-dropdown>
    </div>
  </div>
  <div class="col-gc20">
    <div class="field">
      <ng-container>
        <label>Patient</label>
        <div class="p-inputgroup table-search-wrapper">
          <span class="p-inputgroup-addon"><img src="../../assets/images/search.svg" alt="search.svg" /></span>
          <input
            (ngModelChange)="this.search.next($event)"
            [(ngModel)]="searchByPatient"
            [placeholder]="onlyAdminRoles() ? searchPatientById : searchPatientByNameOrMrn"
            class="table-search-field w-full"
            type="text"
          />
        </div>
      </ng-container>
    </div>
  </div>
  <div class="col-gc20">
    <div class="field">
      <ng-container>
        <label>Case Manager</label>
        <div class="p-inputgroup table-search-wrapper">
          <span class="p-inputgroup-addon"><img src="../../assets/images/search.svg" alt="search.svg" /></span>
          <input
            (ngModelChange)="this.search.next($event)"
            [(ngModel)]="searchByCaseManager"
            [placeholder]="searchByCaseManagerPlaceHolder"
            class="table-search-field w-full"
            type="text"
          />
        </div>
      </ng-container>
    </div>
  </div>
  <div class="col-gc20">
    <div class="field">
      <ng-container>
        <label>Clinician</label>
        <div class="p-inputgroup table-search-wrapper">
          <span class="p-inputgroup-addon"><img src="../../assets/images/search.svg" alt="search.svg" /></span>
          <input
            (ngModelChange)="this.search.next($event)"
            [(ngModel)]="searchByClinician"
            [placeholder]="searchByClinicianPlaceHolder"
            class="table-search-field w-full"
            type="text"
          />
        </div>
      </ng-container>
    </div>
  </div>
  <div class="col-gc25">
    <div class="field">
      <label>Visit Date</label>
      <div class="p-inputgroup table-calendar-wrapper">
        <span class="p-inputgroup-addon"><img src="assets/images/calendar.svg" alt="calendar.svg" /></span>
        <p-calendar
          (onClear)="onCalendarClear()"
          (onSelect)="selectVisitDate()"
          [(ngModel)]="rangeDates"
          [readonlyInput]="true"
          class="w-full"
          dateFormat="{{ datePickerFormat }}"
          inputId="range"
          ngDefaultControl
          placeholder="{{ datePickerPlaceholder }}"
          selectionMode="range"
        ></p-calendar>
        <button (click)="onCalendarClear()" *ngIf="rangeDates != null" class="clearBtn">
          <img alt="" src="assets/images/error.svg" />
        </button>
      </div>
    </div>
  </div>
</div>

<div class="table-wrapper">
  <div class="table-header">
    <div class="align-items-center flex">
      <div>
        <button
          pButton
          pRipple
          type="button"
          [disabled]="loading"
          class="p-button-rounded p-button-text reload-btn"
          (click)="getSubmissionByPatients()"
        ></button>
      </div>
      <h2>{{ viewByVisitDropdown[0].label }}</h2>
      <div class="user-label">
        <img src="../../assets/images/mdi_user.svg" alt="mdi_user.svg" />
        <span>{{ totalSubmission }}</span>
      </div>
    </div>
  </div>
  <p-table
    #dt
    [sortField]="defaultSortField"
    [sortOrder]="-1"
    [(selection)]="selectedSubmissions"
    [value]="submissionList"
    [customSort]="true"
    [lazy]="true"
    class="visitListingTable"
    dataKey="id"
  >
    <ng-template pTemplate="header">
      <tr class="gc-table-filter">
        <th class="col-1" id="type">
          <div class="flex align-items-center gap-2">
            <span>Type</span>
            <div class="filterClass dd-align-right">
              <img
                class="w-16"
                *ngIf="!selectedSubmissionTypes || !selectedSubmissionTypes.length"
                (click)="typeDropdown.show()"
                src="assets/images/filter-outline.svg"
              />
              <img
                class="w-18"
                *ngIf="selectedSubmissionTypes && selectedSubmissionTypes.length && selectedSubmissionTypes.length > 0"
                (click)="typeDropdown.show()"
                src="assets/images/filter-filled.svg"
              />
              <p-multiSelect
                #typeDropdown
                (onPanelShow)="sortSelectedVisits()"
                (onChange)="onSubmissionTypeDropdownChange()"
                [(ngModel)]="selectedSubmissionTypes"
                [options]="submissionTypes"
                appendTo="body"
                optionLabel="label"
                styleClass="typeMulitselect-dd"
              >
                <ng-template pTemplate="header"
                  ><span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues(selectedSubmissionTypes)"
                    ><img src="assets/images/filter-icn.svg" alt="exclamation.svg" /></span
                ></ng-template>
              </p-multiSelect>
            </div>
          </div>
        </th>
        <th class="col-1" pSortableColumn="visitDate" id="date" (click)="customDateSort()">
          Visit Date
          <p-sortIcon field="visitDate"></p-sortIcon>
        </th>
        <th class="col-1" id="overDueVisits"> Late Visits</th>
        <th class="col-1" id="errorsAndWarnings">Errors & Warnings</th>
        <th class="col-1" id="errorsAndWarnings">Consistency Warnings</th>
        <th class="col-2" id="patient">Patient</th>
        <th class="col-1" id="clinician">
          <div class="flex align-items-center gap-2">
            <span>Created By</span>
            <div class="filterClass">
              <img
                class="w-16"
                *ngIf="!selectedClinician || !selectedClinician.length"
                (click)="dropdown.show()"
                src="assets/images/filter-outline.svg"
              />
              <img
                class="w-18"
                *ngIf="selectedClinician && selectedClinician.length && selectedClinician.length > 0"
                (click)="dropdown.show()"
                src="assets/images/filter-filled.svg"
              />
              <p-multiSelect
                #dropdown
                (onPanelShow)="sortSelectedValues()"
                (onChange)="onSelectClinicianFilter()"
                [(ngModel)]="selectedClinician"
                [options]="clinicianFilter"
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                styleClass="typeMulitselect-dd"
              >
                <ng-template pTemplate="header"
                  ><span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues(selectedClinician)"
                    ><img src="assets/images/filter-icn.svg" alt="exclamation.svg" /></span
                ></ng-template>
              </p-multiSelect>
            </div>
          </div>
        </th>
        <!-- <ng-container *ngIf="allowAdminRoles">
          <th class="col-1" id="map">Map</th>
        </ng-container> -->
        <th id="caseManagerSubmison" class="col-2">
          <div class="flex align-items-center gap-2">
            <span>Case Manager</span>
            <div class="filterClass">
              <img
                class="w-16"
                *ngIf="!selectedCaseManagerName || !selectedCaseManagerName.length"
                (click)="caseManagerDropdown.show()"
                src="assets/images/filter-outline.svg"
              />
              <img
                class="w-18"
                *ngIf="selectedCaseManagerName && selectedCaseManagerName.length && selectedCaseManagerName.length > 0"
                (click)="caseManagerDropdown.show()"
                src="assets/images/filter-filled.svg"
              />
              <p-multiSelect
                #caseManagerDropdown
                (onPanelShow)="sortSelectedValues()"
                (onChange)="onSelectCaseManagerFilter()"
                [(ngModel)]="selectedCaseManagerName"
                [options]="caseManagerFilter"
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                styleClass="typeMulitselect-dd"
              >
                <ng-template pTemplate="header"
                  ><span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues(selectedCaseManagerName)"
                    ><img src="assets/images/filter-icn.svg" alt="exclamation.svg" /></span
                ></ng-template>
              </p-multiSelect>
            </div>
          </div>
        </th>
        <th class="col-2" id="updated">Updated</th>
        <th class="col-1" id="status">
          <div class="flex align-items-center gap-2">
            <span>Visit Status</span>
            <div class="cursor-pointer filterClass dd-align-right">
              <img class="w-16" *ngIf="!selectedSubmissionStatus" (click)="statusDropdown.show()" src="assets/images/filter-outline.svg" />
              <img class="w-18" *ngIf="selectedSubmissionStatus" (click)="statusDropdown.show()" src="assets/images/filter-filled.svg" />
              <p-dropdown
                #statusDropdown
                (onChange)="onSubmissionStatusDropdownChange()"
                [(ngModel)]="selectedSubmissionStatus"
                [autoDisplayFirst]="false"
                [options]="submissionStatus"
                ngDefaultControl
              ></p-dropdown>
            </div>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template let-rowIndex="rowIndex" let-submissionList pTemplate="body">
      <tr (click)="openPatientSubmissionDetails(submissionList)" class="p-selectable-row cursor-pointer">
        <td>
          <span class="image-text">{{ submissionList?.submissionData?.visitType | removeHtml }}</span>
        </td>
        <td>
          <span class="image-text">{{ submissionList?.submissionData?.visitDate | customDate: dateFormat }}</span>
        </td>
        <td>
          <div class="flex gap-1">
           <div [class.errors-label]="submissionList?.overdueVisitCount > 0" [class.success-label]="submissionList?.overdueVisitCount === 0">
              {{ submissionList?.overdueVisitCount }}
            </div>
          </div>
        </td>
        <td>
          <span class="p-column-title">Errors & Warnings</span>
          <div *ngIf="submissionList?.alertCounts?.errorCount > 0 || submissionList?.alertCounts?.warningCount > 0; else normalSection" class="flex gap-1">
            <div [class.errors-label]="submissionList?.alertCounts?.errorCount > 0" [class.success-label]="submissionList?.alertCounts?.errorCount === 0">
              {{ submissionList?.alertCounts?.errorCount }}
            </div>
            <div [class.success-label]="submissionList?.alertCounts?.warningCount === 0" [class.warnings-label]="submissionList?.alertCounts?.warningCount > 0">
              {{ submissionList?.alertCounts?.warningCount }}
            </div>
          </div>
          <ng-template #normalSection>
           <div class="flex gap-1" >
            <div [class.errors-label]="submissionList?.errorCount > 0" [class.success-label]="submissionList?.errorCount === 0">
              {{ submissionList?.errorCount }}
            </div>
            <div [class.success-label]="submissionList?.warningCount === 0" [class.warnings-label]="submissionList?.warningCount > 0">
              {{ submissionList?.warningCount }}
            </div>
          </div>
          </ng-template>
        </td>
        <td>
          <div class="flex gap-1">
            <div
              [class.success-label]="submissionList?.submissionData?.crossRulesIssuesCount === 0"
              [class.warnings-label]="submissionList?.submissionData?.crossRulesIssuesCount > 0"
            >
              {{ submissionList?.submissionData?.crossRulesIssuesCount ? submissionList?.submissionData?.crossRulesIssuesCount : 0 }}
            </div>
          </div>
        </td>
        <td>
          <span class="p-column-title">Patient</span>
          <div class="flex align-items-center gap-3">
            <!--<div class="gc-agency-img" *ngIf="submissionList?.patient?.firstName">
              <app-avatar [firstName]="submissionList.patient.firstName" [lastName]="submissionList.patient.lastName"></app-avatar>
            </div>-->
            <div *ngIf="hidePatientName; else elseBlock" class="flex align-items-center">
              <div>
                <p class="gc-agency-handle w-12rem">
                  {{ submissionList?.patientId | truncate: defaultPatientIdLength }}
                </p>
              </div>
              <div class="">
                <span
                  [escape]="false"
                  class="tooltip-icon"
                  pTooltip="
                        <b>IOH ID:</b> {{ submissionList.submissionData?._id }}<br>
                        <b>Group:</b> {{ submissionList?.submissionData?.group | removeHtml }}<br>
                        <b>Build Version:</b> {{ submissionList?.submissionData?.appBuildVersionNCode }}
                      "
                  tooltipStyleClass="eSocMRNToolTip"
                >
                  <img src="assets/images/exclamation.svg" alt="exclamation.svg"
                /></span>
              </div>
            </div>
            <ng-template #elseBlock>
              <div>
                <p *ngIf="submissionList?.patientName" class="gc-agency-name">
                  {{ submissionList.patientName | removeHtml | truncate: defaultMrnLength }}
                </p>
                <p class="gc-agency-handle">
                  {{ submissionList.submissionData?.mrn | removeHtml | truncate: defaultMrnLength }}
                </p>
              </div>
              <div class="">
                <span
                  [escape]="false"
                  class="tooltip-icon"
                  pTooltip="
                        <b>IOH ID:</b> {{ submissionList.submissionData?._id }}<br>
                        <b>MRN:</b> {{ submissionList?.submissionData.mrn | removeHtml }}<br>
                        <b>Submitted:</b> {{ submissionList?.submissionData?.submissionDate | customDate }}<br>
                        <b>Updated:</b> {{
                    (submissionList?.submissionData?.updatedAt
                      ? submissionList?.submissionData?.updatedAt
                      : submissionList?.submissionData?.submissionDate
                    ) | customDate
                  }}<br>
                        <b>Group:</b> {{ submissionList?.submissionData?.patient?.group | removeHtml }}<br>
                        <b>Build Version:</b> {{ submissionList?.submissionData?.appBuildVersionNCode }}<br>
                      {{ submissionList?.submissionData?.episodeName ? '<b>Episode Name:</b> ' + submissionList?.submissionData?.episodeName : '' }}
                      "
                  tooltipStyleClass="eSocMRNToolTip"
                >
                  <img src="assets/images/exclamation.svg" alt="exclamation.svg"
                /></span>
              </div>
            </ng-template>
          </div>
        </td>
        <td>
          <div>
            <p class="gc-agency-name">
              {{
                (submissionList?.submissionData?.user?.firstName ? submissionList?.submissionData?.user?.firstName : ' ') +
                  ' ' +
                  (submissionList?.submissionData?.user?.lastName ? submissionList?.submissionData?.user?.lastName : '') | removeHtml | truncate: defaultMrnLength
              }}
            </p>
            <p class="gc-agency-handle">
              {{ submissionList?.submissionData?.user?.defaultRole ? '(' + RoleEnum[submissionList?.submissionData?.user?.defaultRole] + ')' : '' }}
            </p>
          </div>
        </td>
        <!-- <ng-container *ngIf="allowAdminRoles">
          <td>
            <span class="p-column-title">Google Map</span>
            <div>
              <ng-container *ngIf="submissionList.submissionData.latitude && submissionList.submissionData.longitude; else notApplicableDiv">
                <div (click)="$event.stopPropagation(); patientSubmission = submissionList; showLocationDialog(submissionList.submissionData.visitDate, submissionList.submissionData.visitType)">
                  <em class="pi pi-map-marker"></em>
                </div>
              </ng-container>
              <ng-template #notApplicableDiv>
                <div (click)="$event.stopPropagation()">Not Applicable</div>
              </ng-template>
            </div>
          </td>
        </ng-container> -->
        <td>{{ submissionList?.patient?.caseManager }}</td>
        <td>
          <span class="image-text">{{
            (submissionList?.submissionData?.updatedAt ? submissionList?.submissionData?.updatedAt : submissionList?.submissionData?.submissionDate)
              | dateElapsedTime
          }}</span>
        </td>
        <td>
          <span class="p-column-title">Status</span>
          <span [style.color]="submissionStatusColorEnum[statusColor(submissionList?.submissionData?.status | lowercase)]" class="image-text">{{
            getLabelByValue(submissionList?.submissionData?.status)
          }}</span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" style="text-align: center">
          <span>
            <em class="pi pi-exclamation-circle mr-2"></em>
            No Submission found
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="paginator-wrapper">
    <p-paginator
      #paginator
      (onPageChange)="paginate($event)"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [rows]="noOfRecordPerRow"
      [totalRecords]="totalSubmission"
      styleClass="gc-paginator"
    ></p-paginator>
  </div>
</div>
<!-- <p-dialog [(visible)]="locationPopupDisplay" [dismissableMask]="true" [modal]="true" [style]="{ width: '400px' }">
  <ng-template pTemplate="header">
    <span>Visit Type: {{ selectedVisitType }} - Visit Date: {{ selectedVisitDates }}</span>
  </ng-template>
  <p-gmap *ngIf="locationPopupDisplay" [options]="options" [overlays]="overlays" [style]="{ 'width': '100%', 'height': '320px' }"></p-gmap>
</p-dialog> -->
<p-sidebar (onHide)="onSlideBarClose()" [(visible)]="display" [showCloseIcon]="false" class="sidebar-lg" position="right">
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <div class="flex align-items-center gap-2">
        <h2 class="gc-form-heading">Visit Details Here</h2>
        <span
          >[{{
            (patientSubmission?.submissionData?.updatedAt
              ? patientSubmission?.submissionData?.updatedAt
              : patientSubmission?.submissionDate
              ? patientSubmission?.submissionDate
              : patientSubmission?.submissionData?.submissionDate
            ) | customDate
          }}]</span
        >
        <span
          [style.color]="
            visitDetailColors[
              patientSubmission?.status ? getLabelByValue(patientSubmission?.status) : getLabelByValue(patientSubmission?.submissionData?.status)
            ]
          "
          >{{
            patientSubmission?.status ? getLabelByValue(patientSubmission?.status) : getLabelByValue(patientSubmission?.submissionData?.status)
          }}</span
        >
      </div>
      <div>
        <span (click)="onSlideBarClose()" class="cursor-pointer"><em class="pi pi-times"></em></span>
      </div>
    </div>
    <br />
    <br />
  </ng-template>
  <ng-template pTemplate="content">
    <app-visit-details
      (closeSideBar)="onSlideBarClose()"
      (eSOCUploadDisplay)="openeSOCUploadPopup()"
      (reloadPatientSubmission)="getSubmissionByPatients()"
      (reprocessedObject)="reprocessedObject($event)"
      [patientSubmission]="patientSubmission"
    ></app-visit-details>
  </ng-template>
</p-sidebar>
<app-esoc-upload
  (eSocPopUpClose)="eSOCUploadPopupClose()"
  (eSockUploadListingRefresh)="refreshListing()"
  *ngIf="eSOCUploadDisplay"
  [currentUserRole]="currentUser.currentUserRole"
  [eSOCUploadDisplay]="eSOCUploadDisplay"
  [patientSubmission]="patientSubmission"
  [userId]="currentUser._id"
>
</app-esoc-upload>
